import React, { FC, useMemo } from "react";

import { isNil } from "lodash";

import { PaymentLineStatuses } from "@api/graphql";

import { StatusBadge } from "./StatusBadge";

import styles from "./RoyaltyStatusBadge.module.scss";

interface RoyaltyStatusBadgeProps {
  cellValue: PaymentLineStatuses | undefined;
}

type LabelAndClassName = {
  label: string | undefined;
  className: string;
};

const mapRoyaltyStatusToClass = (paymentLineStatus: PaymentLineStatuses): LabelAndClassName => {
  const map: { [key in PaymentLineStatuses]: LabelAndClassName } = {
    [PaymentLineStatuses.BOUNCED_PAYMENT]: {
      label: "Payment Bounced",
      className: "payment-bounced",
    },
    [PaymentLineStatuses.PAID]: {
      label: "Paid",
      className: "paid",
    },
    [PaymentLineStatuses.PROVISIONAL]: {
      label: "Pending",
      className: "pending",
    },
    [PaymentLineStatuses.READY_TO_PAY]: {
      label: "Pending",
      className: "pending",
    },
    [PaymentLineStatuses.READY_TO_REQUEST]: {
      label: "Pending",
      className: "pending",
    },
    [PaymentLineStatuses.SENT_TO_FINANCE]: {
      label: "Pending",
      className: "pending",
    },
  };
  return map[paymentLineStatus];
};

export const RoyaltyStatusBadge: FC<RoyaltyStatusBadgeProps> = ({ cellValue }) => {
  const currentStatus = useMemo(() => {
    if (!isNil(cellValue)) {
      const { label, className } = mapRoyaltyStatusToClass(cellValue);

      return { label, className };
    }
    return undefined;
  }, [cellValue]);

  if (!cellValue) {
    return <StatusBadge cellClassName="undefined-badge" cellValue="undefined" customStyle={styles} />;
  }

  return <StatusBadge cellClassName={currentStatus?.className} cellValue={currentStatus?.label} customStyle={styles} />;
};
